import React, { useState, useEffect } from 'react';
import tokenManager from '../utils/tokenManager';
import './TokenExpirationWarning.css';

const TokenExpirationWarning = () => {
  const [showWarning, setShowWarning] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(0);

  useEffect(() => {
    const checkExpiration = () => {
      const minutesUntilExpiration = tokenManager.getTimeUntilExpiration();
      
      // Show warning if token expires within 15 minutes and user is active
      if (minutesUntilExpiration > 0 && minutesUntilExpiration <= 15 && tokenManager.isUserActive()) {
        setShowWarning(true);
        setTimeRemaining(Math.ceil(minutesUntilExpiration));
      } else {
        setShowWarning(false);
      }
    };

    // Check every minute
    const interval = setInterval(checkExpiration, 60000);
    
    // Check immediately
    checkExpiration();

    // Listen for token refresh events
    const handleTokenRefreshed = () => {
      setShowWarning(false);
    };

    window.addEventListener('tokenRefreshed', handleTokenRefreshed);

    return () => {
      clearInterval(interval);
      window.removeEventListener('tokenRefreshed', handleTokenRefreshed);
    };
  }, []);

  const handleExtendSession = async () => {
    try {
      await tokenManager.refreshToken();
      setShowWarning(false);
    } catch (error) {
      console.error('Failed to extend session:', error);
    }
  };

  const handleDismiss = () => {
    setShowWarning(false);
  };

  if (!showWarning) {
    return null;
  }

  return (
    <div className="token-expiration-warning">
      <div className="warning-content">
        <div className="warning-icon">⚠️</div>
        <div className="warning-text">
          <h4>Session Expiring Soon</h4>
          <p>Your session will expire in {timeRemaining} minute{timeRemaining !== 1 ? 's' : ''}.</p>
        </div>
        <div className="warning-actions">
          <button 
            className="btn-extend" 
            onClick={handleExtendSession}
          >
            Extend Session
          </button>
          <button 
            className="btn-dismiss" 
            onClick={handleDismiss}
          >
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
};

export default TokenExpirationWarning;
